module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-clientes"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Usuarios del cliente " + _vm._s(_vm.cliente.nombre))])]), _c('div', {
    staticClass: "body"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(0), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, [_vm._l((_vm.lista), function(o) {
    return _c('tr', {
      key: "o",
      staticClass: "row-table"
    }, [(!o.isEditing) ? [_c('td', [_vm._v(_vm._s(o.usuario))]), _c('td', [_vm._v(_vm._s(o.nombre))]), _c('td', [_vm._v(_vm._s(o.cargo))]), _c('td', [_vm._v(_vm._s(o.telefono))]), _c('td', [_vm._v(_vm._s(o.password))]), _c('td', [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          o.isEditing = true
        }
      }
    }, [_vm._v("Editar")]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.remover(o)
        }
      }
    }, [_vm._v("Eliminar")])])])] : [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.usuario),
        expression: "o.usuario"
      }],
      domProps: {
        "value": (o.usuario)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "usuario", $event.target.value)
        }
      }
    })]), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.nombre),
        expression: "o.nombre"
      }],
      domProps: {
        "value": (o.nombre)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "nombre", $event.target.value)
        }
      }
    })]), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.cargo),
        expression: "o.cargo"
      }],
      domProps: {
        "value": (o.cargo)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "cargo", $event.target.value)
        }
      }
    })]), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.telefono),
        expression: "o.telefono"
      }],
      domProps: {
        "value": (o.telefono)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "telefono", $event.target.value)
        }
      }
    })]), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.password),
        expression: "o.password"
      }],
      domProps: {
        "value": (o.password)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "password", $event.target.value)
        }
      }
    })]), _c('td', [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small is-primary",
      on: {
        "click": function($event) {
          return _vm.guardar(o)
        }
      }
    }, [_vm._v("Guardar")]), _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          o.isEditing = false
        }
      }
    }, [_vm._v("Cancelar")])])])]], 2)
  }), (_vm.isAdding) ? [_c('tr', {
    key: "nuevo",
    staticClass: "row-table"
  }, [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nuevo.usuario),
      expression: "nuevo.usuario"
    }],
    domProps: {
      "value": (_vm.nuevo.usuario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nuevo, "usuario", $event.target.value)
      }
    }
  })]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nuevo.nombre),
      expression: "nuevo.nombre"
    }],
    domProps: {
      "value": (_vm.nuevo.nombre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nuevo, "nombre", $event.target.value)
      }
    }
  })]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nuevo.cargo),
      expression: "nuevo.cargo"
    }],
    domProps: {
      "value": (_vm.nuevo.cargo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nuevo, "cargo", $event.target.value)
      }
    }
  })]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nuevo.telefono),
      expression: "nuevo.telefono"
    }],
    domProps: {
      "value": (_vm.nuevo.telefono)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nuevo, "telefono", $event.target.value)
      }
    }
  })]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nuevo.password),
      expression: "nuevo.password"
    }],
    domProps: {
      "value": (_vm.nuevo.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nuevo, "password", $event.target.value)
      }
    }
  })]), _c('td', [_c('div', {
    staticClass: "contenedor-acciones"
  }, [_c('button', {
    staticClass: "button is-small is-primary",
    on: {
      "click": function($event) {
        return _vm.insertar()
      }
    }
  }, [_vm._v("Guardar")]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        _vm.isAdding = false
      }
    }
  }, [_vm._v("Cancelar")])])])])] : _vm._e()], 2)], 1), _c('div', [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.isAdding = true
      }
    }
  }, [_vm._v("Nuevo")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Email")]), _c('th', [_vm._v("Nombre")]), _c('th', [_vm._v("Cargo")]), _c('th', [_vm._v("Telefono")]), _c('th', [_vm._v("Password")]), _c('th')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a59820b8","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Cliente_Contact_List.vue
// module id = 523
// module chunks = 1